import { COMPANY, USER } from "../shared/tagTypes";
import { baseApi } from "./base";

const companyApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [COMPANY, USER],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCompanies: builder.query({
        query: (payload) => ({
          url: "/companies",
          params: {
            businessTypeId: payload.businessTypeId,
            includingDisabled: !payload.onlyActive
          },
        }),
        providesTags: [COMPANY],
      }),
      getCompany: builder.query({
        query: (payload) => ({
          url: `/companies/${payload.id}`
        }),
        providesTags: [COMPANY],
      }),
      createCompany: builder.mutation({
        query: (payload) => ({
          url: "/companies",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: [COMPANY],
      }),
      updateCompany: builder.mutation({
        query: (payload) => ({
          url: `/companies/${payload.id}`,
          method: "PUT",
          body: payload.body,
        }),
        invalidatesTags: [COMPANY],
      }),
      deleteCompany: builder.mutation({
        query: (payload) => ({
          url: `/companies/${payload.id}`,
          method: "DELETE",
        }),
        invalidatesTags: [COMPANY],
      }),
      sortCompanies: builder.mutation({
        query: (payload) => ({
          url: "/companies/sort",
          method: "POST",
          body: payload,
        }),
      }),
      getCompanyUsers: builder.query({
        query: (payload) => ({
          url: `/companies/${payload.id}/users`,
          params: {
            ...(payload.roleId && {
              roleId: payload.roleId,
            }),
            ...(payload.type && {
              userType: payload.type,
            }),
          },
        }),
        providesTags: [USER],
      }),
      createCompanyUser: builder.mutation({
        query: (payload) => ({
          url: `/companies/${payload.id}/users`,
          method: "POST",
          body: payload.body,
        }),
        invalidatesTags: [USER],
      }),
      updateCompanyUser: builder.mutation({
        query: (payload) => ({
          url: `/companies/${payload.id}/users/${payload.userId}`,
          method: "PUT",
          body: payload.body,
        }),
        invalidatesTags: [USER],
      }),
    }),

    overrideExisting: false,
  });

export const {
  useGetCompaniesQuery,
  useLazyGetCompaniesQuery,
  useGetCompanyQuery,
  useLazyGetCompanyQuery,
  useCreateCompanyMutation,
  useUpdateCompanyMutation,
  useDeleteCompanyMutation,
  useSortCompaniesMutation,
  useGetCompanyUsersQuery,
  useLazyGetCompanyUsersQuery,
  useCreateCompanyUserMutation,
  useUpdateCompanyUserMutation
} = companyApi;
